module.exports = __webpack_public_path__ + "img/related-materials-del.002a0247.svg";